export default __webpack_public_path__ + "static/media/Scenes_01.1f246370.png";